// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_bn9-W","bg1":"index_bg1_McX7Q","bg2":"index_bg2_RKhsu","content":"index_content_E9eoP","container":"index_container_KnPIK"};